import React from 'react';
import { extractNumericRate } from '../../../utils/extractNumericRate';
import { useIsSeasonalSale } from '../../../hooks';
import { useCurrentModule } from '../../ModuleProvider';

/**
 * Maps an auto-applied coupon code to its display label in the checkout summary.
 * During a Studio seasonal sale (gated behind specs.premium.Studio_Sale_PREM2-19136),
 * the sale's coupon is relabeled as "X% off" instead of the raw coupon name.
 *
 * Returns empty string for non-sale state so the platform's default label wins.
 */
export const useCouponLabel = () => {
  const module = useCurrentModule();
  const {
    t
  } = module.internals.useTranslations();
  const isSeasonalSale = useIsSeasonalSale();
  const {
    data: discountData
  } = module.SDK.studioOfferingApiClient.hooks.useFetchOfferingDiscount({});
  return React.useCallback(_couponName => {
    var _discountData$discoun;
    if (isSeasonalSale && discountData != null && (_discountData$discoun = discountData.discount) != null && _discountData$discoun.rate) {
      const percent = parseInt(extractNumericRate(discountData.discount.rate), 10);
      if (!Number.isNaN(percent)) {
        // Reuse the existing Eclipse coupon-label key so we don't duplicate
        // the same "{percent}% OFF" string in Babel under two namespaces.
        return t('sale.product.x_off', {
          percent
        });
      }
    }
    return '';
  }, [isSeasonalSale, discountData, t]);
};
//# sourceMappingURL=useCouponLabel.js.map